import React from 'react';
import classNames from 'classnames/bind';
import { Metric } from "../../../../metric";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Container = function Container(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    events: {
      headerMetric: ['handleViewModalSearch']
    },
    mode: "viewport"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('search-container', className)
  }, children));
};
export var Section = function Section(_ref2) {
  var children = _ref2.children,
    _ref2$isBottomFixed = _ref2.isBottomFixed,
    isBottomFixed = _ref2$isBottomFixed === void 0 ? false : _ref2$isBottomFixed;
  return /*#__PURE__*/React.createElement("section", {
    className: cx('wrapper-section', {
      'wrapper-section__fixed-bottom': isBottomFixed
    })
  }, children);
};